import React, { createContext, useContext, useEffect, useState } from 'react';
import { SERVER_URL } from '../api';
import { tokenData } from '../const';

const UserGroupContext = createContext()

export default function UserGroupProvider({ children }) {
    const [UserGroup, setUserGroup] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!tokenData?.token) return
        fetchUserGroup()
    }, []);

    const fetchUserGroup = () => {
        setLoading(true);
        try {
            fetch(`${SERVER_URL + "group/usergroups"}`, {
                headers: {
                    'Authorization': `Bearer ${tokenData?.token}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    setUserGroup(data.results);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log('Error fetching data:', error);
                    setLoading(false);
                });
        } catch (error) {
            console.log("Error: ", error)
        }
    }
    
    // console.log("UserGroup========>",UserGroup)

    return (
        <UserGroupContext.Provider value={{ UserGroup, loading, setUserGroup, fetchUserGroup }}>
            {children}
        </UserGroupContext.Provider>
    )
}

export function useUserGroup() {
    return useContext(UserGroupContext)
}